import { render, staticRenderFns } from "./ApproveRejectReferenceAction.vue?vue&type=template&id=6791c122&"
import script from "./ApproveRejectReferenceAction.vue?vue&type=script&lang=js&"
export * from "./ApproveRejectReferenceAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
